// /blade-credit-fd/creditUserInfo/offlineCreditApply
import axios from '../utils/axios'
export const offlineCreditApply = (data) => {
    return new Promise((resolve, reject) => {
        let url = '/api/blade-credit-fd/creditUserInfo/offlineCreditApply';
        axios({
          headers: {
            'Content-Type': 'application/json',
          },
          url: url,
          method: "post",
          data: data
        })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }



  // /blade-credit-fd/fd/dic/listDic/{key}    标识(I:所属行业,R:借款人与其所属企业关系,PS:房产状态)
  export const listDic = (key) => {
    return new Promise((resolve, reject) => {
      let url = '/api/blade-credit-fd/fd/dic/listDic/'+key;
      axios.get(url)
        .then((res) => {
          return resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }


// WEBPACK FOOTER //
// ./src/api/offlineCreditApply.js